import compact from 'lodash/fp/compact';
import isEmpty from 'lodash/fp/isEmpty';

import { getMultipleMetadataBatched } from '@lumapps/metadata/api';
import type { Metadata } from '@lumapps/metadata/types';

export interface FetchCommunityMetadataParams {
    metadataIds: string[];
}

export const fetchCommunityMetadata = async (params: FetchCommunityMetadataParams): Promise<Metadata[]> => {
    const { metadataIds } = params;

    if (isEmpty(metadataIds)) {
        return [];
    }

    const metadataList = await getMultipleMetadataBatched(metadataIds, ['id', 'name', 'parent', 'familyKey']);

    return compact(metadataList);
};
